export const cmvCost = {
	label: "Costos",
	export: "Exportar a Excel",
	selectTotalCost: "Costo total de la selección",
	storageTotalCost: "Costo total en inventario",
	averageCostSelection: "Costo promedio x precio de venta de la selección",
	averageCost: "Costo promedio x precio de venta",
	alert: "¡Atención! Existen productos con cantidad negativa que deben ser revisados.",
	products: "Productos",
	showAll: "Mostrar todos {{count}} producto(s)",
	showLess: "Mostrar menos",
	filter: {
		label: "Filtrar por",
		storage: {
			title: "Inventario",
			label: "Seleccionar inventario",
			all: "Todos los inventarios",
		},
		category: {
			title: "Categoría",
			label: "Seleccionar categoría",
			all: "Todas las categorías",
		},
		product: {
			title: "Producto",
			label: "Seleccionar producto",
			all: "Todos los productos",
		},
		clear: "Limpiar filtro",
		apply: "Filtrar",
	},
	table: {
		checkbox: "No mostrar elementos con ficha técnica",
		columns: {
			name: "Producto",
			code: "SKU",
			count: "Cantidad",
			averageCost: "Costo promedio",
			stockValue: "Valor en inventario",
			realCost: "Precio de venta",
			margin: "Margen",
		},
	},
	sheet: {
		title: "Informe de Costos",
		fileName: "informe-de-costos",
		name: "Producto",
		fiscalCode: "SKU",
		count: "Cantidad",
		unityCount: "Cantidad (Unidad)",
		averageCost: "Costo promedio",
		stockValue: "Valor en inventario",
		realCost: "Precio de venta",
		margin: "Margen",
	},
};
